// extracted by mini-css-extract-plugin
export var avatarContainer = "_94-0";
export var avatarTypingWave = "_94-i";
export var gray = "_94-f";
export var green = "_94-c";
export var icon = "_94-9";
export var image = "_94-1";
export var lg = "_94-6";
export var md = "_94-5";
export var presenceDot = "_94-b";
export var red = "_94-d";
export var sm = "_94-4";
export var status = "_94-a";
export var typingDot = "_94-h";
export var typingPill = "_94-g";
export var xl = "_94-7";
export var xs = "_94-3";
export var xxl = "_94-8";
export var xxs = "_94-2";
export var yellow = "_94-e";